import React from 'react';
import { Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUserTag, faUserEdit, faSpinner, faFileImage, faUpload, faCheck, faExclamation, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { faSteam, faDiscord } from '@fortawesome/free-brands-svg-icons';
import Dropzone from 'react-dropzone';
import ReactAvatarEditor from 'react-avatar-editor';
import UsersOnline from '../UsersOnline/UsersOnline';

const validate = values => {
    const errors = {};
    if (!values.displayName) {
        errors.displayName = '* Required';
    } else if (values.displayName.length < 2) {
        errors.displayName = '* Must be more than 2 characters';
    }
    if (!values.email) {
        errors.email = '* Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = '* Invalid email address'
    }
    return errors;
};

const normalizeIds = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '');
    return onlyNums
};

const ProfileForm = props => {
    let dropzoneRef;
    return (
        <Form onSubmit={props.handleSubmit}>
            <Row>
                <Col md={10}>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faUserTag} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <Field component={TextField}
                                name="displayName"
                                type="text"
                                label="Display Name"
                                fullWidth
                                onChange={this.handleChange}
                                helperText={<span></span>}
                            />
                        </div>
                    </div>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faEnvelope} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <Field component={TextField}
                                name="email"
                                type="email"
                                label="Email"
                                fullWidth
                                onChange={this.handleChange}
                                helperText={<span></span>}
                            />
                        </div>
                        <div className="adt-flex-item-small">
                            {
                                (props.user.emailVerified) ?
                                    (<span className="text-primary"><FontAwesomeIcon icon={faCheck} fixedWidth /> Verified</span>)
                                    :
                                    (
                                        <Button disabled={props.verifySent} onClick={() => props.verify()} type="button">
                                            <FontAwesomeIcon className="text-danger" icon={faExclamation} fixedWidth />
                                            <span className="text-danger">Not Verified</span>
                                            <br />{(!props.verifySent) ? (<span>Re-send Code</span>) : (<span>Sent!</span>)}
                                            </Button>)
                            }
                        </div>
                    </div>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faSteam} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <Field component={TextField}
                                name="steamId"
                                type="integer"
                                label="Steam Id"
                                fullWidth
                                normalize={normalizeIds}
                                onChange={this.handleChange}
                                helperText={<span>Your Steam ID looks like 76561197961103742</span>}
                            />
                        </div>
                    </div>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faDiscord} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <Field component={TextField}
                                name="discordId"
                                type="integer"
                                label="Discord Id"
                                fullWidth
                                normalize={normalizeIds}
                                onChange={this.handleChange}
                                helperText={<span>Your Discord ID looks like 91947259435958272</span>}
                            />
                        </div>
                    </div>
                </Col>
                <Col md={2}>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faUserCircle} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <p style={{margin:"0"}}>Avatar</p>
                        </div>
                    </div>
                    <Dropzone
                        accept="image/jpeg, image/png, image/gif"
                        ref={(node) => { dropzoneRef = node; }}
                        onDrop={props.handleDrop}
                        disableClick
                        multiple={false}
                        maxSize={5242880}
                        style={{ width: '200px', height: '200px' }}
                    >
                        <ReactAvatarEditor ref={props.setEditorRef} width={500} height={500} style={{width:"200px", height:"200px", margin:"0"}} image={props.image} />
                    </Dropzone>
                    <div className="clearfix" style={{padding: "5px", width:"200px"}}>
                        <div className="pull-left">
                            <Button type="button" onClick={() => { dropzoneRef.open() }}>
                                <FontAwesomeIcon className="text-primary" icon={faFileImage} fixedWidth /> Browse
                            </Button>
                        </div>
                        <div className="pull-right">
                            <Button type="button" disabled={!props.image} onClick={() => { props.saveAvatar() }}>
                                <FontAwesomeIcon className="text-primary" icon={faUpload} fixedWidth /> Upload
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>

            { props.errors ?
                 props.errors.displayName ? (<Alert bsStyle="danger">{props.errors.displayName}</Alert>) : (null)
                 : (null)
            }
            <Button type="submit" disabled={props.pristine || props.pending}>
                {(props.pending) ? (
                <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                ) : (<FontAwesomeIcon className="text-primary" icon={faUserEdit} fixedWidth /> )}
                <span> Update</span>
            </Button>
        </Form>
    )
};

export default reduxForm({ form: 'profile', validate })(ProfileForm)


// WEBPACK FOOTER //
// ./src/Auth/ProfileForm.js